import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { openModal } from "../../business/redux/reducers/modal/actions";
import { callLead } from "../../business/redux/reducers/leads/actions";
import { CreateTemplateContent } from "../../components/modal/informationModal/contents/campaignContent/createTemplateContent";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Button, Link, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function BasicMenu({ lead }) {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const { auth } = useSelector((s) => s);

  const open = Boolean(anchorEl);

  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const sendSmsLeadHandler = () =>
    dispatch(
      openModal({
        style: { width: "780px" },
        content: (
          <CreateTemplateContent
            type={"sms"}
            lead={lead}
            handleClose={handleClose}
          />
        ),
      })
    );

  const sendEmailLeadHandler = () =>
    dispatch(
      openModal({
        style: { width: "780px" },
        content: (
          <CreateTemplateContent
            type={"email"}
            lead={lead}
            handleClose={handleClose}
          />
        ),
      })
    );

  return (
    <div>
      <Button
        id="sub-menu_button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </Button>
      <Menu
        id="sub-menu"
        className="sub_menu_lead"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        <MenuItem
          onClick={async () => {
            await callLead(auth?.__raw, 12);
            handleClose();
          }}
        >
          <Button variant="outlined" startIcon={<PhoneOutlinedIcon />}>
            Call now
          </Button>
        </MenuItem>

        <MenuItem onClick={sendSmsLeadHandler}>
          <Button variant="outlined" startIcon={<SmsOutlinedIcon />}>
            Send SMS
          </Button>
        </MenuItem>

        <MenuItem onClick={sendEmailLeadHandler}>
          <Button variant="outlined" startIcon={<EmailOutlinedIcon />}>
            Send email
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
}

function Div(props) {
  return null;
}

Div.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
const columns = (dispatch) => [
  {
    field: "Job_Number",
    headerName: "Job Number",
    type: "string",
    flex: 0.8,
    renderCell: (v) => (
      <Link
        target="_blank"
        underline="hover"
        className="job_number"
        href={`https://crm.zoho.com/crm/org692830833/tab/Leads/${v.row.zoho_id}`}
      >
        {v.formattedValue}
      </Link>
    ),
  },
  {
    field: "Job_Date",
    headerName: "Job Date",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Job_Date">
        {v.row.Job_Date}
      </Typography>
    ),
  },
  {
    field: "proposal_created_at",
    headerName: "Proposal Date",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Proposal_Date">
        {v.row.proposal_created_at}
      </Typography>
    ),
  },
  {
    field: "Last_Name",
    headerName: "Last Name",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Last_Name">
        {v.row.Last_Name}
      </Typography>
    ),
  },
  {
    field: "Lead_Stage",
    headerName: "Lead Stage",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Lead_Stage">
        {v.row.Lead_Stage}
      </Typography>
    ),
  },
  {
    field: "Move_Type",
    headerName: "Move Type",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Move_Type">
        {v.row.Move_Type}
      </Typography>
    ),
  },
  {
    field: "Owner_name",
    headerName: "Owner name",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Owner_name">
        {v.row.Owner_name}
      </Typography>
    ),
  },
  {
    field: "Total_Cubic_Ft",
    headerName: "Total Cubic Ft",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="Total_Cubic_Ft">
        {v.row.Total_Cubic_Ft}
      </Typography>
    ),
  },
  {
    field: "estimated_price",
    headerName: "Estimated Price",
    type: "string",
    flex: 1,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="estimated_price">
        {v.row.estimated_price}
      </Typography>
    ),
    footerComponent: ({ column }) => {
      // В реальном приложении вы бы вычисляли сумму из данных
      const sum = 1234; // Здесь должна быть логика вычисления суммы
      return <div>Sum: {sum}</div>;
    },
  },
  {
    field: "office_location",
    headerName: "Office Location",
    type: "string",
    flex: 1.5,
    renderCell: (v) => (
      <Typography variant="div" component="div" className="office_location">
        {v.row.office_location}
      </Typography>
    ),
  },
];
const initialCampaignCreateState = {
  leads: [],
  name: "",
  // started_date: dayjs(),
  type: "sms",
  settings: {
    callDelay: 3,
    template: "",
  },
  userId: 4064759000069945023,
};

export { columns, initialCampaignCreateState };
